const nav = document.querySelector('.nav--main');
if (!nav) throw new Error('No .nav--main found');

const header = document.querySelector('header');
const triggers = nav.querySelectorAll('.nav-item--trigger');

const setHeaderOpen = (open) => {
	header.classList.toggle('megamenu-is-open', open);
};

const closeAll = (except = null) => {
	triggers.forEach(trigger => {
		if (trigger === except) return;
		const menu = document.getElementById(trigger.getAttribute('aria-controls'));
		trigger.setAttribute('aria-expanded', 'false');
		if (menu) {
			menu.classList.remove('is-open');
			menu.setAttribute('inert', '');
		}
	});

	// If no menu is open after closing, remove header state
	const anyOpen = [...triggers].some(t => t.getAttribute('aria-expanded') === 'true');
	setHeaderOpen(anyOpen);
};

triggers.forEach(trigger => {
	const menuId = trigger.getAttribute('aria-controls');
	const menu = document.getElementById(menuId);
	if (!menu) return;

	trigger.addEventListener('click', (e) => {
		e.stopPropagation();
		const isOpen = trigger.getAttribute('aria-expanded') === 'true';

		closeAll(trigger);

		trigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
		menu.classList.toggle('is-open', !isOpen);
		menu.toggleAttribute('inert', isOpen);
		setHeaderOpen(!isOpen);
	});

	trigger.addEventListener('keydown', (e) => {
		if (e.key === 'Escape') {
			closeAll();
			trigger.focus();
		}
	});

	menu.addEventListener('keydown', (e) => {
		if (e.key === 'Escape') {
			closeAll();
			trigger.focus();
		}
	});
});

document.addEventListener('click', (e) => {
	if (!header.contains(e.target)) closeAll();
});

window.addEventListener('resize', () => closeAll());
